import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DentalEmrComponent } from "./Dental-Emr.component";

const routes: Routes = [{ path: "", component: DentalEmrComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DentalEmrRoutingModule {}
